/**
 * TanStack Router: /recruitment/new
 *
 * This route file was auto-generated by the route generation script.
 * Component: RecruitmentNewPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RecruitmentNewPage from '@/app/recruitment/new/page'

/**
 * Route: /recruitment/new
 * Layout: _auth (authenticated)
 * Component: RecruitmentNewPage
 */
export const Route = createFileRoute('/_auth/recruitment/new')({
  component: RecruitmentNewPage,
})
